'use strict';

import React, { PropTypes } from 'react';
import ClassNameMixin from '../mixins/ClassNameMixin';
import PureRenderMixin from '../mixins/PureRenderMixin';
import './LinkDescription.less';

const LinkDescription = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    withMaxWidth: PropTypes.bool
  },

  getCSSModifiers() {
    return {
      withMaxWidth: this.props.withMaxWidth
    };
  },

  render() {
    return (
      <p className={this.getClassName()}>
        {this.props.children}
      </p>
    );
  }
});

export default LinkDescription;


/** WEBPACK FOOTER **
 ** ./atoms/LinkDescription.jsx
 **/